import { Component, OnInit, OnDestroy, Input, SimpleChanges, OnChanges } from '@angular/core';
import { UntypedFormGroup, UntypedFormArray, UntypedFormControl, UntypedFormBuilder } from '@angular/forms';
import { generateTimeOptions } from '@utils/times-utils';
import { generateDefaultActiveShippingDaysNTimesConfig } from '@app/pages/checkout-app/checkout-layout/main/components/extensions/components/extension-components/date-picker/components/date-picker-shipping-days-n-times/configs';
@Component({
  selector: 'date-picker-shipping-days-n-times',
  templateUrl: './date-picker-shipping-days-n-times.component.html',
  styleUrls: ['./date-picker-shipping-days-n-times.component.scss'],
  standalone: false,
})
export class DatePickerShippingDaysNTimesComponent implements OnInit, OnDestroy, OnChanges {
  @Input() formGroup: UntypedFormGroup;
  @Input() loadedValues;
  readonly times = generateTimeOptions();
  readonly formArrayFieldName = 'activeShippingDays';
  activeShippingDaysNTimes = generateDefaultActiveShippingDaysNTimesConfig();
  formArray: UntypedFormArray;
  constructor(private fb: UntypedFormBuilder) {}
  ngOnDestroy() {}
  ngOnInit() {
    this.reinitializeForm();
  }
  getFormArray(): UntypedFormArray {
    return this.formGroup.get(this.formArrayFieldName) as UntypedFormArray;
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['formGroup'] && !changes['formGroup'].firstChange) {
      this.reinitializeForm();
    }
  }
  private reinitializeForm(): void {
    this.formArray = this.getFormArray();
    this.formArray.clear();
    this.initForm(this.loadedValues ?? this.activeShippingDaysNTimes);
  }
  initForm(values) {
    values.forEach((value) => {
      const newActiveShippingDay = this.fb.group({
        day: value.day,
        active: new UntypedFormControl(value.active ?? null),
        from: new UntypedFormControl(value.from ?? null),
        to: new UntypedFormControl(value.to ?? null),
        upToOrders: new UntypedFormControl(value.upToOrders ?? null),
        skipDefaultSelection: new UntypedFormControl(value.skipDefaultSelection ?? null),
      });
      this.formArray.push(newActiveShippingDay);
    });
  }
}
